import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const CATEGORY_COLLISION_ITEM_NAME = 'CategoryCollisionItem';
export const CATEGORY_COLLISION_ITEM_SLOTS: Array<
	keyof CategoryCollisionItemClasses
> = ['root'] as const;

export type CategoryCollisionItemSlot =
	(typeof CATEGORY_COLLISION_ITEM_SLOTS)[number];

export interface CategoryCollisionItemClasses {
	root: string;
}

export type CategoryCollisionItemClassKey = keyof CategoryCollisionItemClasses;

export const getCategoryCollisionItemUtilityClass = (slot: string) =>
	generateUtilityClass(
		CATEGORY_COLLISION_ITEM_NAME,
		slot as CategoryCollisionItemSlot,
	);

export const categoryCollisionItemClasses: CategoryCollisionItemClasses =
	generateUtilityClasses(CATEGORY_COLLISION_ITEM_NAME, ['root']);

export default categoryCollisionItemClasses;
